import React from 'react';
import { Card, Space, Typography } from 'antd';
import { HomeOutlined, MenuOutlined } from '@ant-design/icons';
import { getMountDisplayInfo, getDiskDisplayInfo } from '../../../lib/helpers';

const { Text } = Typography;

const StorageInformation = React.memo(({ storage, isVmMigration, osType }) => {
    if (!storage) return null;

    const getStorageIcon = (mount_name) => {
        if (mount_name?.trim()?.toLowerCase() === 'c' || mount_name?.trim() === '/') {
            return <HomeOutlined />;
        }
        return <MenuOutlined />;
    };

    return (
        <Card title="Storage Information" size="small" type="inner">
            <Space orientation="vertical">
                {/* For VM-based migration, show vm_disks */}
                {isVmMigration && storage.vm_disks && Object.keys(storage.vm_disks).length > 0 && (
                    <div>
                        <Text strong>Disks ({getDiskDisplayInfo(storage.vm_disks).length})</Text>
                        {getDiskDisplayInfo(storage.vm_disks).map((disk, index) => (
                            <div key={index} className={'margin-left-16'}>
                                <Text>
                                    {disk.disk_label}, Size: {disk.size} GiB, {disk.disk_provisioning_type}
                                </Text>
                            </div>
                        ))}
                    </div>
                )}

                {/* For OS-based migration, show mounts */}
                {!isVmMigration && storage.mounts && Object.keys(storage.mounts).length > 0 && (
                    <div>
                        <Text strong>Mounts ({getMountDisplayInfo(osType, storage.mounts, false, false).length})</Text>
                        {getMountDisplayInfo(osType, storage.mounts, false, false).map((mount, index) => (
                            <div key={index}>
                                {getStorageIcon(mount.mount_name)}{' '}
                                <Text>
                                    {mount.mount_name} Size: {mount.size} GiB, Free: {mount.free} GiB
                                </Text>
                            </div>
                        ))}
                    </div>
                )}
            </Space>
        </Card>
    );
});

export default StorageInformation;
